module.exports = __webpack_public_path__ + "static/media/Frame 427319007.3cc590d6.svg";